export const trimToAdminPath = (path: string) => {
  if (!path) return '';

  const adminIndex = path.indexOf('/ADMIN');

  return adminIndex >= 0 ? path.slice(adminIndex) : path;
};
